<template class="pendencyBody">
  <div class="tat-dashboard-container">
    <div>
      <CustomLoader v-if="isLoading" :width="70" />
    </div>

    <!-- Dashboard Header -->
    <div class="dashboard-header">
      <div class="header-content">
        <h2 class="dashboard-title">
          <i class="fas fa-chart-line"></i>
          TAT Dashboard
        </h2>
        <div class="header-stats">
          <div class="stat-card">
            <span class="stat-number">{{ totalData }}</span>
            <span class="stat-label">Total Jobs</span>
          </div>
          <div class="stat-card green">
            <span class="stat-number">{{ getStatusCount('green') }}</span>
            <span class="stat-label">On Track</span>
          </div>
          <div class="stat-card red">
            <span class="stat-number">{{ getStatusCount('red') }}</span>
            <span class="stat-label">Delayed</span>
          </div>
        </div>
      </div>
    </div>

    <b-card class="main-content-card">
      <div class="mt-3">
        <!-- Search Form Input Start -->
        <b-row>
          <b-col md="6" class="my-1">
            <b-form-group>
              <b-input-group>
                <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="Filter.search_txt"
                  placeholder="Type to Search Assignment" ref="search" />
                <b-input-group-append class="mr-1">
                  <b-button :disabled="!Filter.search_txt" @click="filterClear">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="5">
            <b-button class="pull-right ml-1" :variant="Filter.createdByFilter ||
              Filter.branchFilter ||
              Filter.PrealertFilter ||
              Filter.SOBFilter ||
              Filter.isFinalBillingStatus ||
              Filter.booking_number ||
              Filter.container_number ||
              Filter.MblNoFilter ||
              Filter.HblNoFilter ||
              Filter.assignmentFilter ||
              Filter.dateStatusFilter ||
              Filter.billingFilter ||
              Filter.slineFilter ||
              Filter.clientFilter ||
              Filter.liner_bl_release_statusFilter ||
              Filter.line_inv_statusFilter ||

              Filter.search_txt ||
              Filter.createdAtRange.startDate ||
              Filter.createdAtRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' pull-right mb-1' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.createdByFilter ||
                  Filter.branchFilter ||
                  Filter.PrealertFilter ||
                  Filter.SOBFilter ||
                  Filter.isFinalBillingStatus ||
                  Filter.booking_number ||
                  Filter.container_number ||
                  Filter.MblNoFilter ||
                  Filter.HblNoFilter ||
                  Filter.assignmentFilter ||
                  Filter.dateStatusFilter ||
                  Filter.billingFilter ||
                  Filter.slineFilter ||
                  Filter.clientFilter ||
                  Filter.liner_bl_release_statusFilter ||
                  Filter.line_inv_statusFilter ||

                  Filter.search_txt ||
                  Filter.createdAtRange.startDate ||
                  Filter.createdAtRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>

            <b-button class="pull-right mb-1" v-if="JOBList && JOBList.length > 0"
              :disabled="ExcelBtnName !== 'Export As Excel'" @click="getReports('checkJobPendency', 'Export As Excel')"
              size="sm" variant="warning" style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName !== 'Export As Excel'" small label="Small Spinner"></b-spinner>
            </b-button>
          </b-col>

          <b-col md="1">
            <h5>
              <small v-if="!isLoading">{{ totalData }} Entries</small>
            </h5>
          </b-col>
        </b-row>

        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date</label>

                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.createdAtRange"
                    :startDate="startDate" :endDate="endDate" :locale-data="locale"
                    @update="fetchTATData('Normal', '0', '0', '1', '1')"></date-range-picker>
                </b-col>
                <b-col md="3">
                  <label>Booking NO Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Booking NO Filter"
                    id="booking_number" name="booking_number" autocomplete="off" v-model="Filter.booking_number"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>
                <b-col md="3">
                  <label>Container No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Container No Filter"
                    id="container_number" name="container_number" autocomplete="off" v-model="Filter.container_number"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>
                   <b-col md="3">
                  <label>MBL No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search MBL No Filter"
                    id="MblNoFilter" name="MblNoFilter" autocomplete="off" v-model="Filter.MblNoFilter"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>
                   <b-col md="3">
                  <label>HBL No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search HBL No Filter"
                    id="HblNoFilter" name="HblNoFilter" autocomplete="off" v-model="Filter.HblNoFilter"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>
                   <b-col md="3">
                  <label>Job No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Job No Filter"
                    id="assignmentFilter" name="assignmentFilter" autocomplete="off" v-model="Filter.assignmentFilter"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>
                <b-col md="3">
                  <label>Months/Year</label>
                  <model-list-select :list="dateStatusList" v-model="Filter.dateStatusFilter" option-value="inv"
                    option-text="int" placeholder="Select Invoice Status"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>
                <b-col md="3">
                  <label>Billing Status</label>
                  <model-list-select :list="BillingStatusList" v-model="Filter.isFinalBillingStatus" option-value="inv"
                    option-text="int" placeholder="Select Invoice Status"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>
                <b-col md="3">
                  <label>Invoice Status</label>
                  <model-list-select :list="invoiceStatusList" v-model="Filter.billingFilter" option-value="inv"
                    option-text="int" placeholder="Select Invoice Status"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>
                <b-col md="3">
                  <label>Sob Status</label>
                  <model-list-select :list="SOBStatusList" v-model="Filter.SOBFilter" option-value="inv"
                    option-text="int" placeholder="Select Sob Status"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>
                <b-col md="3">
                  <label>Prealert Status</label>
                  <model-list-select :list="PrealertStatusList" v-model="Filter.PrealertFilter" option-value="inv"
                    option-text="int" placeholder="Select Prealert Status"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>
                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineFilter" option-value="shippingId" option-text="shippingLine"
                    placeholder="Select Shipping Line" @input="fetchTATData('Normal', '0', '0', '1', '1')"
                    :disabled="isLoading" />
                </b-col>
                <b-col md="3">
                  <label>Client</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name" @input="fetchTATData('Normal', '0', '0', '1', '1')"
                    :disabled="isLoading" />
                </b-col>
                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                    v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>

                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="search_txt" name="search_txt" autocomplete="off" v-model="Filter.search_txt"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" :disabled="isLoading" />
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="fetchTATData('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName" placeholder="Select Created User"
                    :disabled="isLoading" />
                </b-col>

                <b-col cols="3">
                  <label for="liner-bl-release-status">Liner BL Release Status</label>
                  <model-list-select :list="mblInvoiceStatus" id="liner_bl_release_status" @input="debounceSearch"
                    v-model="Filter.liner_bl_release_statusFilter" option-value="value" option-text="label"
                    placeholder="Select MBL Status" />
                </b-col>
                <b-col cols="3">
                  <label for="liner-bl-release-status">Line Invoice Status</label>
                  <model-list-select :list="lineInvoiceStatus" id="line_inv_status" @input="debounceSearch"
                    v-model="Filter.line_inv_statusFilter" option-value="value" option-text="label"
                    placeholder="Select Line Invoice Status" />
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <!-- Advanced Table Layout -->
        <div class="card">
          <div class="card-header bg-primary text-white">
            <div class="d-flex justify-content-between align-items-center">
              <span class="h6 mb-0">
                Total Records: {{ JOBList && JOBList.length || 0 }}
              </span>
            </div>
          </div>

          <div class="card-body p-0">
            <div class="table-responsive" v-if="JOBList && JOBList.length > 0">
              <b-table :items="JOBList" :fields="tableFields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection" :tbody-tr-class="rowClass" striped hover bordered small class="mb-0"
                :busy="isLoading">
                <!-- TAT Analysis Column -->
                <template slot="tatAnalysis" slot-scope="data">
                  <div v-if="data.item" class="d-flex flex-column">
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">Inv Upload:</span>
                      <span class="badge badge-sm ml-1 badge-secondary">
                        {{ data.item.InvUploadTatSobPlusOneDays || 0 }}d
                      </span>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">MBL Release:</span>
                      <span class="badge badge-sm ml-1 badge-secondary">
                        {{ data.item.MblReleaseTatSobPlusTwoDays || 0 }}d
                      </span>
                    </div>
                    <small class="text-muted">Accounts:     <span class="badge badge-sm ml-1 badge-secondary"> {{ data.item.DaysFromMBLToSendToAccounts || 0 }}d </span></small><br>
                    <small class="text-muted">Payment:      <span class="badge badge-sm ml-1 badge-secondary">{{ data.item.OEPaymentFirstSob || 0 }}d </span></small><br>
                    <small class="text-muted">File Close:      <span class="badge badge-sm ml-1 badge-secondary">{{ data.item.TatForFileClosingMblReleasePlusFourDays || 0
                      }}d </span></small>
                  </div>
                </template>

                <!-- Job Details Column -->
                <template slot="jobDetails" slot-scope="data">
                  <div v-if="data.item" class="d-flex flex-column">
                    <div class="font-weight-bold">
                      {{ data.item.JobNo }}
                    </div>
                    <div class="d-flex flex-wrap gap-1 mb-1">
                      <span class="badge badge-secondary">{{ formatDate(data.item.JobDate) }}</span>
                      <span class="badge badge-secondary">{{ data.item.JobType }}</span>
                    </div>
                    <small class="text-muted">{{ data.item.TransportType }} | {{ data.item.FclLcl }}</small>
                    <div class="mt-1">
                      <small class="text-muted"><strong>Mode:</strong> {{ data.item.Mode }}</small><br>
                      <small class="text-muted"><strong>Code:</strong> {{ data.item.JobCode }}</small>
                    </div>
                  </div>
                  <div v-if="data.item" class="d-flex flex-column">
                    <div class="font-weight-bold">
                      {{ truncateText(data.item.ShippingLine, 20) }}
                    </div>
                    <div>{{ data.item.BookingNo }}</div>
                    <div class="mt-1">
                      <small class="text-muted"><strong>Type:</strong> {{ data.item.FreightContainersType }}</small><br>
                      <small class="text-muted"><strong>Count:</strong> {{ data.item.MultipleContainerNo }}</small>
                    </div>
                  </div>
                  <div v-if="data.item" class="d-flex flex-column">
                    <div class="font-weight-bold">
                      {{ truncateText(data.item.ClientName, 25) }}
                    </div>
                    <div class="text-muted">
                      {{ data.item.RaisedFrom }}
                    </div>
                    <small class="text-muted">By: {{ data.item.RaisedBy }}</small>
                    <div class="mt-1">
                      <small class="text-muted"><strong>Billing:</strong> {{ data.item.billingType }}</small><br>
                      <small class="text-muted"><strong>User:</strong> {{ data.item.SentToAccountsUser }}</small>
                    </div>
                  </div>
                </template>

                <!-- Route Column -->
                <template slot="route" slot-scope="data">
                  <div v-if="data.item" class="d-flex flex-column">
                    <div class="d-flex align-items-center">
                      <span class="badge badge-light">{{ getPortCode(data.item.POR) }}</span>
                      <span class="mx-1 text-muted">→</span>
                      <span class="badge badge-light">{{ getPortCode(data.item.POL) }}</span>
                      <span class="mx-1 text-muted">→</span>
                      <span class="badge badge-light">{{ getPortCode(data.item.POD) }}</span>
                    </div>
                    <div v-if="data.item" class="d-flex flex-column">
                      <div class="font-weight-bold">
                        Vessel / Voyage: {{ data.item.VesselVoyage || 'N/A' }}
                      </div>
                      <small class="text-muted">{{ data.item.Mode }} | {{ data.item.FclLcl &&
                        data.item.FclLcl.toUpperCase() }}</small>
                      <div class="mt-1">
                        <small class="text-muted"><strong>SOB:</strong> <span class="badge badge-secondary">{{
                            data.item.Sob }}</span></small><br>
                        <small class="text-muted"><strong>Overseas:</strong> {{ data.item.closedOverseasStatus
                        }}</small>
                      </div>
                    </div>
                    <small class="text-muted mt-1"><strong>Terms:</strong> {{ data.item.DeliveryTerms }}</small>
                    <small class="text-muted d-block"><strong>Contract:</strong> {{ data.item.ContractNo || 'N/A'
                    }}</small>
                  </div>
                </template>

                <!-- Documents Column -->
                <template slot="documents" slot-scope="data">
                  <div v-if="data.item" class="d-flex flex-column">
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">MBL:</span>
                      <span class="ml-1">{{ data.item.MblNo || 'N/A' }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">HBL:</span>
                      <span class="ml-1">{{ data.item.HblNo || 'N/A' }}</span>
                    </div>
                    <small class="text-muted">SB: {{ data.item.ShippingBillNo || 'N/A' }}</small><br>
                    <small class="text-muted">Invoice: {{ data.item.ShipperInvNo || 'N/A' }}</small><br>
                    <small class="text-muted">MBL Date: <span class="badge badge-secondary">{{ data.item.MblReleaseDate
                        || 'N/A' }}</span></small>
                  </div>
                </template>

                <!-- Additional Info Column -->
                <template slot="additionalInfo" slot-scope="data">
                  <div v-if="data.item" class="d-flex flex-column">
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">User:</span>
                      <span class="ml-1">{{ data.item.SentToAccountsUser || 'N/A' }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">Billing:</span>
                      <span class="ml-1">{{ data.item.billingType || 'N/A' }}</span>
                    </div>
                    <small class="text-muted">BL Status: {{ data.item.BlReleaseStatus || 'N/A' }}</small><br>
                    <small class="text-muted">Sline Pay: {{ data.item.SlinePaymentStatus || 'N/A' }}</small><br>
                    <small class="text-muted">Prealert: {{ data.item.PrealertStatus || 'N/A' }}</small>
                  </div>
                </template>

                <!-- Billing & Accounts Column -->
                <template slot="billingAccounts" slot-scope="data">
                  <div v-if="data.item" class="d-flex flex-column">
                    <div v-if="data.item.HblReleaseDate" class="d-flex justify-content-between mb-1">
                      <span class="text-muted">HBL Release:</span>
                      <span class="badge badge-secondary">{{ data.item.HblReleaseDate }}</span>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">Sline Req:</span>
                      <span class="ml-1"><span class="badge badge-secondary">{{ data.item.SlineInvoiceRequestDate ||
                          'N/A' }}</span></span>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">MBL Release Date:</span>
                      <span class="ml-1"><span class="badge badge-secondary">{{ data.item.MblReleaseDate || 'N/A'
                          }}</span></span>
                    </div>
                    <!-- <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">Inv Upload TAT:</span>
                      <span class="ml-1">{{ data.item.InvUploadTatSobPlusOneDays || 0 }}d</span>
                    </div> -->
                    <!-- <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">MBL Release TAT:</span>
                      <span class="ml-1">{{ data.item.MblReleaseTatSobPlusTwoDays || 0 }}d</span>
                    </div> -->
                    <small class="text-muted">Accounts User: {{ data.item.SentToAccountsUser || 'N/A' }}</small><br>
                    <small class="text-muted">Sent Date: <span class="badge badge-secondary">{{
                      data.item.SentToAccountsDate || 'N/A' }}</span></small><br>
                    <!-- <small class="text-muted">Days to Accounts: {{ data.item.DaysFromMBLToSendToAccounts || 0
                      }}d</small> -->
                  </div>
                </template>

                <!-- Submissions Column -->
                <template slot="submissions" slot-scope="data">
                  <div v-if="data.item" class="d-flex flex-column">
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">VGM:</span>
                      <span class="ml-1"><span class="badge badge-secondary">{{ data.item.VgmSubmissionDateActual ||
                          'N/A' }}</span></span>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">SI:</span>
                      <span class="ml-1"><span class="badge badge-secondary">{{ data.item.SiSubmissiondateActual ||
                          'N/A' }}</span></span>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">TR:</span>
                      <span class="ml-1"><span class="badge badge-secondary">{{ data.item.TrSubmissiondateActual ||
                          'N/A' }}</span></span>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                      <span class="text-muted">Handover:</span>
                      <span class="ml-1"><span class="badge badge-secondary">{{ data.item.HandoverDateActual || 'N/A'
                          }}</span></span>
                    </div>
                    <!-- <small class="text-muted">Shipper Inv: {{ data.item.ShipperInvNo || 'N/A' }}</small><br>
                    <small class="text-muted">Shipping Bill: {{ data.item.ShippingBillNo || 'N/A' }}</small> -->
                  </div>
                </template>

                <!-- Complete Data Column -->
                <template slot="completeData" slot-scope="data">
                  <div v-if="data.item" class="d-flex flex-column">
                    <h6 class="mb-2">
                      Additional Fields
                    </h6>
                    <div class="d-flex flex-column">
                      <div v-if="data.item.HblReleaseDate" class="d-flex justify-content-between mb-1">
                        <span class="text-muted">HBL Release:</span>
                        <span class="badge badge-secondary">{{ data.item.HblReleaseDate }}</span>
                      </div>
                      <div v-if="data.item.HblReleaseTatSobPlusOneDays" class="d-flex justify-content-between mb-1">
                        <span class="text-muted">HBL TAT:</span>
                        <span>{{ data.item.HblReleaseTatSobPlusOneDays }}d</span>
                      </div>
                      <div v-if="data.item.BillingInvTatFromClosingMblPlusTwoDays"
                        class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Billing TAT:</span>
                        <span>{{ data.item.BillingInvTatFromClosingMblPlusTwoDays }}d</span>
                      </div>
                      <div v-if="data.item.TatForFileClosingMblReleasePlusFourDays"
                        class="d-flex justify-content-between mb-1">
                        <span class="text-muted">File Closing TAT:</span>
                        <span>{{ data.item.TatForFileClosingMblReleasePlusFourDays }}d</span>
                      </div>
                      <div v-if="data.item.RInvNo" class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Reverse Tally:</span>
                        <span>{{ data.item.RInvNo }}</span>
                      </div>
                      <div v-if="data.item.ReverseTallyInvDate" class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Rev Tally Date:</span>
                        <span class="badge badge-secondary">{{ data.item.ReverseTallyInvDate }}</span>
                      </div>
                      <div v-if="data.item.OEPaymentFirstSob !== null" class="d-flex justify-content-between mb-1">
                        <span class="text-muted">OE Payment:</span>
                        <span>{{ data.item.OEPaymentFirstSob }}d</span>
                      </div>
                      <div v-if="data.item.DaysFromOEPaymentFirst" class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Days from OE:</span>
                        <span>{{ data.item.DaysFromOEPaymentFirst }}d</span>
                      </div>
                      <div v-if="data.item.frghtTermsHbl" class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Freight Terms HBL:</span>
                        <span>{{ data.item.frghtTermsHbl }}</span>
                      </div>
                      <div v-if="data.item.frghtTermsMbl" class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Freight Terms MBL:</span>
                        <span>{{ data.item.frghtTermsMbl }}</span>
                      </div>
                      <div v-if="data.item.status_verbose" class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Status Verbose:</span>
                        <span>{{ data.item.status_verbose }}</span>
                      </div>
                      <div v-if="data.item.IsRollover" class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Rollover:</span>
                        <span>{{ data.item.IsRollover }}</span>
                      </div>
                      <div v-if="data.item.IsManifestation" class="d-flex justify-content-between mb-1">
                        <span class="text-muted">Manifestation:</span>
                        <span>{{ data.item.IsManifestation }}</span>
                      </div>
                    </div>
                  </div>
                </template>

                <!-- Loading slot -->
                <template slot="table-busy">
                  <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                  </div>
                </template>
              </b-table>
            </div>

            <!-- Empty State -->
            <div v-else class="text-center py-5">
              <i class="fa fa-inbox fa-3x text-muted mb-3"></i>
              <h4 class="text-muted">No Jobs Found</h4>
              <p class="text-muted">There are no jobs to display at the moment.</p>
            </div>
          </div>
        </div>

        <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
          :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
      </div>
    </b-card>

    <b-modal size="xl" id="doc" class="modal-dialog-doc" no-close-on-esc no-close-on-backdrop ref="doc-modal"
      hide-footer :title="'Assignment Summary & Documents - ' + JOBSERIES">
      <div v-if="ALLMODULE">
        <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal">Close</b-button>
    </b-modal>
    <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import DateRangePicker from "vue2-daterange-picker";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE_DOC } from "../../helper/constant.js";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";

import UpdateCBModal from '../Pendency/UpdateCBModal.vue';
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import ContaierWebLogSummary from "../common/moduleBasedContaierWebLogSummary.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";
import InvExpSummary from "../common/moduleBasedInvExpSummary.vue";
import userBasedClient from "../common/userBasedClient.vue";
import CustomLoader from "../common/customLoader.vue";
import TATService from "../../services/TATService";
import MasterService from "../../services/MasterService";

export default {
  beforeMount() {
    this.$store.dispatch(
      "common/setAllFilterBranchList",
      JSON.stringify({
        filter: "getFilterBranchList",
        active: "all",
      })
    );
    this.$store.dispatch(
      "common/setAllBranchList",
      JSON.stringify({
        filter: "BranchList",
        active: "all",
      })
    ),

      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),
      this.initializePage();
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  data() {
    return {
      isModalOpen: false,
      ALLMODULE: "",
      JOBSERIES: "",
      visible: false,
      isLoading: false,
      totalRows: 0,
      filter: null,
      docURL: URL_BASE_DOC,
      ExcelBtnName: "Export As Excel",
      is_custom_excel: 0,
      dateStatusList: [
        {
          inv: "125",
          int: "4 Month",
        },
        {
          inv: "186",
          int: "6 Month",
        },
        {
          inv: "248",
          int: "8 Month",
        },
        {
          inv: "300",
          int: "10 Month",
        },
        {
          inv: "367",
          int: "1 Year",
        },
        {
          inv: "734",
          int: "2 Year",
        },

        {
          inv: "0",
          int: "Global ALL",
        },
      ],
      BillingStatusList: [
        {
          inv: "1",
          int: "Completed",
        },
        {
          inv: "0",
          int: "Pending",
        },
        {
          inv: "2",
          int: "All",
        },
      ],
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "2",
          int: "Sent to Accounts",
        },
        {
          inv: "3",
          int: "Billing Not Started",
        },
        {
          inv: "4",
          int: "Not To Be Billed",
        },
        {
          inv: "",
          int: "All",
        },
      ],
      PrealertStatusList: [
        {
          inv: "1",
          int: "Yes",
        },
        {
          inv: "2",
          int: "No",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      Filter: {
        createdByFilter: "",
        PrealertFilter: "3",
        isFinalBillingStatus: "",
        SOBFilter: "3",
        dateStatusFilter: "125",
        branchFilter: (this.$sessionsStorage.get('designation') != 'Admin' && this.$sessionsStorage.get('userId') != 13) ? this.$sessionsStorage.get('branch_baseLocation') : "",
        booking_number: "",
        container_number: "",
        MblNoFilter: "",
        HblNoFilter: "",
        assignmentFilter: "",
        billingFilter: "",
        slineFilter: "",
        clientFilter: "",
        liner_bl_release_statusFilter: "",
        line_inv_statusFilter: "",
        search_txt: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      columnMain: this.initializeColumns(),
      JOBList: [],
      debounce: null,
      pagination: {
        currentPage: 1,
        perPage: 50,
      },
      showCal: false,
      startDate: "",
      endDate: "",
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      lineInvoiceStatus: [
        { label: "Not Received from Line", value: 1 },
        { label: "Not Initiated", value: 0 },
        { label: "Paid", value: 2 },
        { label: "Dispute Raised", value: 3 },
        { label: "Send for Payment", value: 4 }
      ],
      mblInvoiceStatus: [
        { label: "Released", value: 1 },
        { label: "Sailed - NOT RELEASED", value: 0 },
        { label: "NOT RELEASED", value: 2 },
      ],
      totalData: 0,
      generateExcel: "0",
      expandedRows: {},
      tableViewMode: 'compact',
      sortColumn: '',
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      tableFields: [
        {
          key: 'tatAnalysis',
          label: 'TAT Analysis',
          sortable: false,
          thClass: 'text-left',
          thStyle: { width: '140px' }
        },
        {
          key: 'additionalInfo',
          label: 'Additional Info',
          sortable: false,
          thClass: 'text-left',
          thStyle: { width: '140px' }
        },
        {
          key: 'billingAccounts',
          label: 'Billing & Accounts',
          sortable: false,
          thClass: 'text-left',
          thStyle: { width: '160px' }
        },
        {
          key: 'submissions',
          label: 'Submissions',
          sortable: false,
          thClass: 'text-left',
          thStyle: { width: '140px' }
        },
        {
          key: 'jobDetails',
          label: 'Job Details',
          sortable: true,
          sortKey: 'JobNo',
          thClass: 'text-left',
          thStyle: { width: '150px' }
        },
        {
          key: 'route',
          label: 'Route',
          sortable: false,
          thClass: 'text-left',
          thStyle: { width: '120px' }
        },
        {
          key: 'documents',
          label: 'Documents',
          sortable: false,
          thClass: 'text-left',
          thStyle: { width: '150px' }
        },
        {
          key: 'completeData',
          label: 'Complete Data',
          sortable: false,
          thClass: 'text-left',
          thStyle: { width: '200px' }
        },
      ],
    };
  },
  computed: {
    next7Days() {
      const days = [];
      const today = new Date();

      for (let i = 0; i < 7; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);
        const dateStr = date.toISOString().split('T')[0];
        days.push({
          value: dateStr,
          label: i === 0 ? 'Today' : i === 1 ? 'Tomorrow' : `${i} days from now`
        });
      }

      return days;
    },
  },
  components: {
    ModelListSelect,
    CustomLoader,
    DatePicker,
    DateRangePicker,
    MultiSelect,
    Multiselect,
    UpdateCBModal,
    DocForm,
    AssignmentSummary,
    ContainerSummary,
    JobWisePaymentsDetails,
    ContaierWebLogSummary,
    RejectInvTallyBillSummary,
    InvExpSummary,
    userBasedClient,
  },
  methods: {
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String("04").padStart(2, "0");
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0");
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd;
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd;

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0");
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd;
      this.startDate = today;
      this.Filter.createdAtRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
      this.fetchTATData("Normal", "0", "0", "1", "1");
    },
    clearFilter() {
      this.Filter = {
        createdByFilter: "",
        PrealertFilter: "3",
        isFinalBillingStatus: "",
        SOBFilter: "3",
        dateStatusFilter: "125",
        branchFilter: (this.$sessionsStorage.get('designation') != 'Admin' && this.$sessionsStorage.get('userId') != 13) ? this.$sessionsStorage.get('branch_baseLocation') : "",
        booking_number: "",
        container_number: "",
        MblNoFilter: "",
        HblNoFilter: "",
        assignmentFilter: "",
        billingFilter: "",
        slineFilter: "",
        clientFilter: "",
        liner_bl_release_statusFilter: "",
        line_inv_statusFilter: "",
        search_txt: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.fetchTATData("Normal", "0", "0", "1", "1");
    },
    filterClear() {
      this.Filter = {
        createdByFilter: "",
        PrealertFilter: "3",
        isFinalBillingStatus: "",
        SOBFilter: "3",
        dateStatusFilter: "125",
        branchFilter: (this.$sessionsStorage.get('designation') != 'Admin' && this.$sessionsStorage.get('userId') != 13) ? this.$sessionsStorage.get('branch_baseLocation') : "",
        booking_number: "",
        container_number: "",
        MblNoFilter: "",
        HblNoFilter: "",
        assignmentFilter: "",
        billingFilter: "",
        slineFilter: "",
        clientFilter: "",
        liner_bl_release_statusFilter: "",
        line_inv_statusFilter: "",
        search_txt: "",
        createdAtRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
    },
    initializePage() {
      this.getCurrentLastDate();
      lastVisitPage(this.$router.history.current.fullPath);
      const loginId = this.$sessionsStorage.get("loginId");
      if (!loginId) return this.$router.push({ path: "/Login/" });

      this.$store.dispatch("setCurrentRoute", this.$route.path);
      if (globalPermissionStatus("Sea Freight")) {
        this.fetchTATData("Normal", "0", "0", "1", "1");
      } else {
        this.$router.push({ path: "/dashboard" });
      }

      this.$store.dispatch("common/setAllUserList", JSON.stringify({ itemCode: "GET_USERLIST_Data" }));
    },
    initializeColumns() {
      return [
        { key: "SN", mainkey: "SN", label: "SN.", sortable: true, table: "HJ." },
        { key: "RaisedFrom", mainkey: "RaisedFrom", label: "Branch", sortable: true, table: "A." },
        { key: "BookingNo", mainkey: "BookingNo", label: "Booking No", sortable: true, table: "B." },
        { key: "JOBNO", mainkey: "JOBNO", label: "JOB Details", sortable: true, table: "C." },
        { key: "clientName", mainkey: "clientName", label: "Client", sortable: true, table: "D." },
        { key: "shippingLine", mainkey: "shippingLine", label: "Sline", sortable: true, table: "E." },
        { key: "POR", mainkey: "POR", label: "POR - POL - POD", sortable: true, table: "F." },
        { key: "vgmcut_off_date_est", mainkey: "vgmcut_off_date_est", label: "VGM Date/Cutoff", sortable: true, table: "J." },
        { key: "si_cutoff_est", mainkey: "si_cutoff_est", label: "SI Date/Cutoff", sortable: true, table: "K." },
        { key: "tr_cutoff_date_est", mainkey: "tr_cutoff_date_est", label: "TR Date/CutOFF", sortable: true, table: "L." },
        { key: "handoverDate_actual", mainkey: "handoverDate_actual", label: "Handover Date/CutOFF", sortable: true, table: "L." },
        { key: "oe_payment_status", mainkey: "oe_payment_status", label: "Sline Payment Date", sortable: true, table: "M." },
        { key: "SOB", mainkey: "SOB", label: "SOB", sortable: true, table: "N." },
        { key: "SysETA_actual", mainkey: "SysETA_actual", label: "ETA Destination(Actual, Estimated)", sortable: true, table: "O." },
      ];
    },
    goPage(item) {
      console.log("Navigate to job page for:", item);
    },
    debounceSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => this.fetchTATData("Normal", "0", "0", "1", "1"), 500);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.fetchTATData("Excell", "0", "0", "1", "1");
    },
    onPageChange: function (event) {
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.fetchTATData("Normal", "0", CURRENT, "2", event);
    },
    fetchTATData(type, filterId, currentPage, searchType, pageNumber) {
      this.totalData = 0;
      this.JOBList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getBookingResp",
        type: type,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        perPage: this.pagination.perPage,
        pageSize: this.pagination.perPage,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        is_custom_excel: this.is_custom_excel,
        record_type: "",
        is_client_template: 1,
      };

      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};
      TATService.getTATJobList(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log("data PS=>", data);

          if (status == 200 && data) {
            if (this.generateExcel == "1") {
              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `TAT_Report_${new Date().toISOString().split('T')[0]}.xlsx`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.is_custom_excel = "0";
              this.fetchTATData("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.total;
                this.JOBList = data.data;
                // Setup scroll bars after data is loaded
                this.setupScrollBars();
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getBookingResp Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    shouldBlink: function (item) {
      return item.CustomColorColumn === "red";
    },
    isBlinking: function (item) {
      return item.CustomColorColumn === "red";
    },
    showDocModal(item) {
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.JobNo;
      this.$bvModal.show('doc');
    },
    hideDocModal() {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.$bvModal.hide('doc');
    },
    goToSubscriptionPage(item) {
      console.log("Navigate to subscription page for:", item);
    },
    goVGMPage(item) {
      console.log("Navigate to VGM page for:", item);
    },
    openModal(item) {
      this.$refs.updateCBModal.openModal();
    },
    updateData() {
      this.fetchTATData("Normal", "0", "0", "1", "1");
    },
    getStatusCount(color) {
      if (!this.JOBList || !Array.isArray(this.JOBList)) return 0;
      return this.JOBList.filter(job => job && job.CustomColorColumn === color).length;
    },
    getDateStatus(date) {
      if (!date || date === 'Pending') return 'pending';
      const today = new Date();
      const dueDate = new Date(date);
      if (dueDate < today) return 'overdue';
      if (dueDate <= new Date(today.getTime() + 3 * 24 * 60 * 60 * 1000)) return 'warning';
      return 'on-time';
    },
    getInvoiceStatusClass(status) {
      if (!status || typeof status !== 'string') return 'warning';
      if (status.includes('Received') || status.includes('Done')) return 'success';
      if (status.includes('Pending') || status.includes('Not Received')) return 'danger';
      return 'warning';
    },

    // Check if status is "Received" for green check mark
    isStatusReceived(status) {
      if (!status || typeof status !== 'string') return false;
      return status.toLowerCase().includes('received');
    },

    // Get text class for invoice status
    getInvoiceStatusTextClass(status) {
      if (!status || typeof status !== 'string') return '';
      if (status.toLowerCase().includes('received')) return 'status-received';
      return '';
    },
    getPaymentStatusClass(status) {
      if (!status || typeof status !== 'string') return 'info';
      if (status === 'Paid') return 'success';
      if (status === 'Send for Payment') return 'warning';
      if (status.includes('Dispute')) return 'danger';
      return 'info';
    },
    formatLocation(location) {
      if (!location) return '';
      return location.split(',')[0] || location;
    },
    toggleRowExpansion(allModuleId) {
      this.$set(this.expandedRows, allModuleId, !this.expandedRows[allModuleId]);
    },
    expandAll() {
      if (!this.JOBList || !Array.isArray(this.JOBList)) return;
      this.JOBList.forEach(job => {
        if (job && job.allModuleId) {
          this.$set(this.expandedRows, job.allModuleId, true);
        }
      });
    },
    collapseAll() {
      this.expandedRows = {};
    },
    setTableView(mode) {
      this.tableViewMode = mode;
    },
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },
    rowClass(item, type) {
      if (!item || type !== 'row') return '';

      const classes = [];

      if (item.CustomColorColumn === 'red') {
        classes.push('row-delayed');
      } else if (item.CustomColorColumn === 'green') {
        classes.push('row-on-track');
      }

      return classes.join(' ');
    },
    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    getPortCode(portName) {
      if (!portName) return '';
      const parts = portName.split(',');
      return parts[parts.length - 1].trim() || portName.substring(0, 6);
    },
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('en-GB');
    },
    formatDateShort(date) {
      if (!date || date === 'Pending') return date;
      return new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit' });
    },
    getStatusIcon(status) {
      if (!status || typeof status !== 'string') return '◐';

      // Convert to lowercase for consistent checking
      const statusLower = status.toLowerCase();

      if (statusLower.includes('received') || statusLower.includes('done') || statusLower.includes('completed')) {
        return '✓';
      }
      if (statusLower.includes('not received') || statusLower.includes('pending') || statusLower.includes('not initiated')) {
        return '✗';
      }
      if (statusLower.includes('paid') || statusLower.includes('send for payment')) {
        return '✓';
      }
      if (statusLower.includes('dispute')) {
        return '⚠';
      }

      return '◐';
    },
    getOverallStatusClass(job) {
      if (!job || !job.CustomColorColumn) return 'warning';
      if (job.CustomColorColumn === 'red') return 'danger';
      if (job.CustomColorColumn === 'green') return 'success';
      return 'warning';
    },
    formatKey(key) {
      if (!key) return '';
      return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, str => str.toUpperCase())
        .trim();
    },
    formatValue(value) {
      if (value === null || value === undefined) return 'N/A';
      if (typeof value === 'boolean') return value ? 'Yes' : 'No';
      if (typeof value === 'string' && value.length > 50) {
        return value.substring(0, 50) + '...';
      }
      return value.toString();
    },

    // Scroll synchronization methods
    syncTopScroll() {
      if (this.$refs.topScrollBar && this.$refs.tableWrapper) {
        this.$refs.topScrollBar.scrollLeft = this.$refs.tableWrapper.scrollLeft;
      }
      if (this.$refs.bottomScrollBar && this.$refs.tableWrapper) {
        this.$refs.bottomScrollBar.scrollLeft = this.$refs.tableWrapper.scrollLeft;
      }
    },

    syncScrollFromTop() {
      if (this.$refs.tableWrapper && this.$refs.topScrollBar) {
        this.$refs.tableWrapper.scrollLeft = this.$refs.topScrollBar.scrollLeft;
      }
      if (this.$refs.bottomScrollBar && this.$refs.topScrollBar) {
        this.$refs.bottomScrollBar.scrollLeft = this.$refs.topScrollBar.scrollLeft;
      }
    },

    syncScrollFromBottom() {
      if (this.$refs.tableWrapper && this.$refs.bottomScrollBar) {
        this.$refs.tableWrapper.scrollLeft = this.$refs.bottomScrollBar.scrollLeft;
      }
      if (this.$refs.topScrollBar && this.$refs.bottomScrollBar) {
        this.$refs.topScrollBar.scrollLeft = this.$refs.bottomScrollBar.scrollLeft;
      }
    },

    setupScrollBars() {
      this.$nextTick(() => {
        if (this.$refs.tableWrapper && this.$refs.topScrollBar && this.$refs.bottomScrollBar) {
          const tableWidth = this.$refs.tableWrapper.scrollWidth;
          const wrapperWidth = this.$refs.tableWrapper.clientWidth;

          // Set scroll bar widths to match table content
          this.$refs.topScrollBar.style.width = tableWidth + 'px';
          this.$refs.bottomScrollBar.style.width = tableWidth + 'px';

          // Add event listeners
          this.$refs.topScrollBar.addEventListener('scroll', this.syncScrollFromTop);
          this.$refs.bottomScrollBar.addEventListener('scroll', this.syncScrollFromBottom);
        }
      });
    },
  },
};
</script>

<style>
/* Minimal Bootstrap-only styling with neutral colors and consistent font sizes */
.tat-dashboard-container {
  padding: 20px;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-2 {
  gap: 0.5rem;
}

/* Ensure table fits properly */
.table-responsive {
  overflow-x: auto;
}

/* Custom badge sizes for better visibility */
.badge-sm {
  font-size: 0.5625rem;
  padding: 0.25rem 0.5rem;
}

/* Ensure proper spacing in table cells */
.b-table td {
  vertical-align: top;
  padding: 0.5rem;
  font-size: 0.5625rem;
}

/* Row styling for status indicators - neutral colors */
.row-delayed {
  border-left: 4px solid #6c757d !important;
  background-color: #f8f9fa !important;
}

.row-on-track {
  border-left: 4px solid #6c757d !important;
  background-color: #f8f9fa !important;
}

/* Ensure proper text wrapping */
.text-wrap {
  word-wrap: break-word;
  white-space: normal;
}

/* Standardize all font sizes to 9px */
.b-table th,
.b-table td,
.badge,
.badge-sm,
small,
.text-muted,
.font-weight-bold,
h6,
.b-table,
.b-table * {
  font-size: 0.5625rem !important;
}

/* Neutral color scheme */
.badge-secondary {
  background-color: #6c757d !important;
  color: #ffffff !important;
}

.badge-light {
  background-color: #f8f9fa !important;
  color: #495057 !important;
}

/* Remove all colorful styling */
.text-primary,
.text-info,
.text-success,
.text-warning,
.text-danger {
  color: #495057 !important;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .badge-sm {
    font-size: 0.5625rem;
    padding: 0.2rem 0.4rem;
  }

  .b-table td {
    padding: 0.25rem;
  }
}
</style>



// WEBPACK FOOTER //
// TATDashboard.vue?34250d11